import { getConexions } from "../../utils/axios/index"

/**
 * metodo para traer los modulos activos
 */

export const getVerificarImpresora = async (Impresora) => {
    let res = {};
    try {
      const ApiUrl = await getConexions();
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({Impresora}),
      };
      
      res = await fetch(ApiUrl+"TPrinterInf/getVerificarImpresora", requestOptions );
    } catch (Error) {
      res = Error;
    }
    return res;
  };
 /**
  * 
 */ 
  export const getPingConnection = async () => {
    let res = {};
    try {
      const ApiUrl = await getConexions();
      
    
      res = await fetch(ApiUrl+"TPrinterInf/getPingConnection");
    } catch (Error) {
      res = Error;
      
    }
    return res;
  };
 /**
  * 
  */
  export const getImprimir = async (Config, Ticket) => {
    let res = {};
    try {
      const ApiUrl = await getConexions();
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({Config,Ticket}),
      };
      
      res = await fetch(ApiUrl+"TPrinterInf/ImprimeTicket", requestOptions);
    } catch (Error) {
      res = Error;
    }
    return res;
   
}